module.exports = __webpack_public_path__ + "img/book5-active.80c0ca65.png";